var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "15.998px",
    height: "16.003px",
    viewBox: "316.498 -25.008 15.998 16.003",
    enableBackground: "new 316.498 -25.008 15.998 16.003",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4e6c63",
    d: "M324.505-25.008c4.42,0.003,7.999,3.594,7.991,8.017 c-0.008,4.421-3.6,7.998-8.021,7.986c-4.407-0.012-7.976-3.591-7.977-8.001C316.498-21.428,320.083-25.011,324.505-25.008z  M322.597-16.227c-0.828-0.626-1.331-1.414-1.44-2.421c-0.111-1.022,0.196-1.915,0.89-2.667c1.194-1.296,3.207-1.429,4.579-0.304 c0.708,0.581,1.127,1.336,1.216,2.248c0.126,1.304-0.398,2.337-1.427,3.141c1.904,0.904,2.434,1.493,3.425,3.777 c1.987-2.088,2.648-6.325-0.173-9.349c-2.79-2.99-7.399-3.034-10.228-0.119c-2.894,2.983-2.343,7.283-0.271,9.482 C319.692-14.248,320.83-15.501,322.597-16.227z M324.504-9.942c1.594-0.027,3.026-0.506,4.296-1.471 c0.16-0.122,0.223-0.239,0.189-0.443c-0.343-2.114-2.272-3.744-4.47-3.765c-2.175-0.021-4.151,1.628-4.511,3.756 c-0.033,0.198,0.013,0.321,0.178,0.447C321.466-10.446,322.907-9.965,324.504-9.942z M324.502-21.443 c-1.33-0.002-2.428,1.087-2.436,2.416c-0.007,1.338,1.105,2.453,2.441,2.444c1.328-0.008,2.421-1.107,2.42-2.435 C326.927-20.346,325.832-21.441,324.502-21.443z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile01);
export default __webpack_public_path__ + "static/media/profile-01.9ce867194b7828b8f97aae198c0c0d0b.svg";
export { ForwardRef as ReactComponent };